import type { ConditionListItem, ConditionStock, WatchlistItem } from "@/types/condition"
import client from "./client"

export async function getConditionList(): Promise<ConditionListItem[]> {
  const { data } = await client.get<ConditionListItem[]>("/api/conditions/list")
  return data
}

export async function getConditionStocks(seq: string): Promise<ConditionStock[]> {
  const { data } = await client.get<ConditionStock[]>(`/api/conditions/${seq}/stocks`)
  return data
}

export async function getConditionResults(seq: string): Promise<WatchlistItem[]> {
  const { data } = await client.get<WatchlistItem[]>(`/api/conditions/${seq}/results`)
  return data
}
